import React from 'react';
import { fetchConnector, FetchPNLAnalyticsPropsFromRedux } from '../dataFetcher';
import { SimpleTableColumnConfig, SimpleTableRow, TableSize } from '../../tables/types';
import { UniqueTableName } from '../../common/uniqueTableName';
import { AllTradesRunDateDataResp } from '../fetchTypes';
import { commonPNLSummaryTableColumns } from '../common/CommonPNLSummaryTable';
import ExpandableTable, { ExpandableTableConfig } from '../../tables/ExpandableTable';
import { PNLGoodiesNonCompletedResponses } from '../PaperPlaceHolder';
import { PNLAnalyticsEndpoint, PNLFetchStatus } from '../../actions/pnlAnalytics';
import { kFormatterAggWithSign } from '../../pnlAnalytics/common/common';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    headerVarCell: {
        borderLeft: 'black solid 1px',
    },
    bodyVarCell: {
        borderLeft: 'black solid 1px',
    },
}));

const pivotColumns: Array<SimpleTableColumnConfig> = [
    {
        name: 'strategy',
        title: 'Strategy',
        hoverElement: (row: SimpleTableRow, val: any) => {
            return <div>{row['strategy']}</div>;
        },
    },
    {
        name: 'deal',
        title: 'Deal',
        hoverElement: (row: SimpleTableRow, val: any) => {
            return <div>{row['deal']}</div>;
        },
    },
];

const allColumns = pivotColumns.concat(commonPNLSummaryTableColumns);

const config: ExpandableTableConfig = {
    uniqueTableName: UniqueTableName.PerStrategyCorpSummary,
    title: 'Corp Summary',
    size: TableSize.Small,
    columns: allColumns,
    grandTotal: true,
    aggFormatVal: kFormatterAggWithSign,
    pivotDepth: 1,
    defaultExpandable: 0,
    stickyHeader: true,
};

const PerStrategyCorpSummary = (props: FetchPNLAnalyticsPropsFromRedux) => {
    const classes = useStyles();
    const allTradesResp = props.pnlAnalytics.all_trades_run_date;

    if (allTradesResp.status !== PNLFetchStatus.COMPLETED) {
        return (
            <PNLGoodiesNonCompletedResponses endpoint={PNLAnalyticsEndpoint.AllTradesRunDate} data={allTradesResp} minHeight={'604px'} />
        );
    }

    config.columns[config.columns.length - 2].headerCellClassName = classes.headerVarCell;
    config.columns[config.columns.length - 2].bodyCellsClassName = classes.bodyVarCell;

    const respData = allTradesResp.data! as AllTradesRunDateDataResp;

    return <ExpandableTable data={respData['per_strategy_corp_pnl_summary']} config={config} />;
};

export default fetchConnector(PerStrategyCorpSummary);
